import bank from "./styles/img/bank.svg";
import crypto from "./styles/img/crypto.svg";
import investment from "./styles/img/investment.svg";
import life_insurance from "./styles/img/life_insurance.svg";
import nft from "./styles/img/nft.svg";
import other from "./styles/img/other.svg";
import password_manager from "./styles/img/password_manager.svg";
import password from "./styles/img/password.svg";
import real_estate from "./styles/img/real_estate.svg";
import retirement from "./styles/img/retirement.svg";
import shares from "./styles/img/shares.svg";
import vault from "./styles/img/vault.svg";
import web3 from "./styles/img/web3.svg";
import will from "./styles/img/will.svg";
import online_storage from "./styles/img/online_storage.svg";
export const selectLogo = (asset_type) => {
  switch (asset_type.toLowerCase()) {
    case "bank account":
      return bank;
    case "crypto wallet":
      return crypto;
    case "life insurance":
      return life_insurance;
    case "investment account":
      return investment;
    case "company shares":
      return shares;
    case "nft":
      return nft;
    case "password manager":
      return password_manager;
    case "password":
      return password;
    case "real estate":
      return real_estate;
    case "retirement plan":
      return retirement;
    case "web 3 assets":
      return web3;
    case "physical vault":
      return vault;
    case "your will":
      return will;
    case "online storage":
      return online_storage;
    default:
      return other;
  }
};
